import React, { ReactNode } from 'react';
import { Box, type Types } from '@fiverr-private/theme';
import { findChildByType } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { FORM_HEADER_ID, FORM_LABEL_ID, FORM_OPTIONAL_LABEL_ID, FORM_SUBTITLE_ID, FORM_TOOLTIP_ID } from '../constants';

interface FormHeaderProps extends Pick<Types.BoxType, 'dataTrackTag' | 'dataTrackValue'> {
  children: ReactNode;
}

const FormHeader = ({ children, dataTrackTag = 'form_header', dataTrackValue }: FormHeaderProps) => {
  const FormLabel = findChildByType(children, FORM_LABEL_ID);
  const FormOptionalLabel = findChildByType(children, FORM_OPTIONAL_LABEL_ID);
  const FormTooltip = findChildByType(children, FORM_TOOLTIP_ID);
  const FormSubtitle = findChildByType(children, FORM_SUBTITLE_ID);

  return (
    <Box dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} as="div" display="flex" direction="column">
      <Stack gap="2" alignItems="center">
        {FormLabel}
        {FormOptionalLabel}
        {FormTooltip}
      </Stack>
      {FormSubtitle}
    </Box>
  );
};

FormHeader.id = FORM_HEADER_ID;
FormHeader.displayName = FORM_HEADER_ID;

export default FormHeader;
